import React from 'react';
import { useTranslate } from 'ra-core';
import { Typography, LinearProgress, makeStyles } from '@material-ui/core';
export const NewPasswordVerifyingToken = props => {
    const translate = useTranslate();
    const classes = useStyles(props);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, { className: classes.title, variant: "body1", gutterBottom: true }, translate('apihub.new_password.notifications.verifying_token')),
        React.createElement(LinearProgress, null)));
};
const useStyles = makeStyles(theme => ({
    root: {},
    title: {
        color: theme.palette.text.primary,
    },
}), {
    name: 'Layer7NewPasswordVerifyingToken',
});
//# sourceMappingURL=NewPasswordVerifyingToken.js.map